import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRunNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M11.553 0c-.868 0-1.712.28-2.408.8l-4.45 3.32a.083.083 0 01-.023.011L.857 5.397A1.25 1.25 0 000 6.583c0 2.1.263 3.68.754 4.951.5 1.29 1.204 2.183 1.96 2.935.403.402.795.748 1.176 1.084 1.058.933 2.03 1.79 2.921 3.547 1.377 3.41 3.153 6.412 5.9 8.553C15.492 29.82 19.133 31 24.033 31c2.91 0 4.871-.84 6.133-2.098 1.24-1.236 1.648-2.72 1.776-3.727.162-1.263-.513-2.303-1.292-2.923l-5.213-4.15a1.416 1.416 0 01-.464-.667L20.83 4.78A2.583 2.583 0 0018.376 3h-2.003c-.482 0-.955.135-1.364.39l-.953.592-.768-2.675A1.805 1.805 0 0011.553 0zm-.913 2.803c.127-.094.267-.168.414-.22l1.513 5.269 3.762-2.34a.083.083 0 01.044-.012h2.003c.036 0 .068.023.08.057L19.908 10H16v2.5h4.727l.491 1.5H17v2.5h5.036l.56 1.713c.239.727.685 1.37 1.284 1.846l4.286 3.411c-1.055.276-2.483.53-4.166.53-2.643 0-4.272-.574-5.448-1.456-1.21-.907-2.082-2.242-3.024-4.074a85.68 85.68 0 01-.924-1.876c-1.537-3.184-3.466-7.18-7.427-11.207zM4.932 6.68c3.957 3.856 5.787 7.636 7.385 10.934.334.689.657 1.357.988 2 .975 1.898 2.06 3.666 3.747 4.931 1.72 1.29 3.924 1.956 6.948 1.956 2.138 0 3.921-.356 5.177-.715l.074-.021a3.598 3.598 0 01-.85 1.368c-.688.686-1.954 1.368-4.368 1.368-4.481 0-7.54-1.07-9.785-2.82-2.266-1.765-3.836-4.327-5.137-7.563a1.263 1.263 0 00-.043-.095c-1.136-2.26-2.585-3.533-3.714-4.524-.324-.285-.621-.546-.877-.8-.584-.582-1.052-1.19-1.391-2.065-.289-.747-.503-1.742-.567-3.154z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRunNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRunNormalMedium;
